import { render, staticRenderFns } from "./platformLog.vue?vue&type=template&id=53280df5&"
import script from "./platformLog.vue?vue&type=script&lang=js&"
export * from "./platformLog.vue?vue&type=script&lang=js&"
import style0 from "./platformLog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports